import ngFocusIf from 'ng-focus-if';
import get from 'lodash/get';

import { InputContainer } from 'components/inputContainer/inputContainer';

import template from './promoCodeForm.html';
import './promoCodeForm.scss';

export const PromoCodeForm = angular
    .module('checkout.components.orderSummary.promoCodeForm', [
        ngFocusIf,
        InputContainer
    ]).component('promoCodeForm', {
        template,
        bindings: {
            onApplyPromoClicked: '<',
            promoCodeNotFound: '<',
            promoCodeExpired: '<',
            inactiveGiftCard: '<',
            giftCardNotAllowed: '<',
            giftCardAlreadyApplied: '<',
            cannotAddMoreStoreCredit: '<',
            discountCodeExistsInCart: '<',
            discountErrorMessage: '<'
        },
        controller: class PromoCodeFormCtrl {
            $onChanges(changesObj) {
                if (changesObj.promoCodeNotFound && !changesObj.promoCodeNotFound.isFirstChange()) {
                    this.setInputValidity('discountExists', !changesObj.promoCodeNotFound.currentValue);
                }

                if (changesObj.promoCodeExpired && !changesObj.promoCodeExpired.isFirstChange()) {
                    this.setInputValidity('discountExpired', !changesObj.promoCodeExpired.currentValue);
                }

                if (changesObj.inactiveGiftCard && !changesObj.inactiveGiftCard.isFirstChange()) {
                    this.setInputValidity('inactiveGiftCard', !changesObj.inactiveGiftCard.currentValue);
                }

                if (changesObj.giftCardNotAllowed && !changesObj.giftCardNotAllowed.isFirstChange()) {
                    this.setInputValidity('giftCardNotAllowed', !changesObj.giftCardNotAllowed.currentValue);
                }

                if (changesObj.giftCardAlreadyApplied && !changesObj.giftCardAlreadyApplied.isFirstChange()) {
                    this.setInputValidity('giftCardAlreadyApplied', !changesObj.giftCardAlreadyApplied.currentValue);
                }

                if (changesObj.cannotAddMoreStoreCredit && !changesObj.cannotAddMoreStoreCredit.isFirstChange()) {
                    this.setInputValidity(
                        'cannotAddMoreStoreCredit',
                        !changesObj.cannotAddMoreStoreCredit.currentValue
                    );
                }

                if (changesObj.discountCodeExistsInCart && !changesObj.discountCodeExistsInCart.isFirstChange()) {
                    this.setInputValidity(
                        'discountCodeExistsInCart',
                        !changesObj.discountCodeExistsInCart.currentValue
                    );
                }
            }

            setInputValidity(validationKey, validity) {
                if (this.promoCodeForm) {
                    this.promoCodeForm.promoCode.$setValidity(validationKey, validity);
                }
            }

            onApplyClicked() {
                this.isApplying = true;
                this.onApplyPromoClicked(this.promoCode).finally(() => {
                    this.isApplying = false;
                    this.promoCode = '';
                });
            }

            onPromoCodeInputChanged() {
                this.setInputValidity('discountExists', true);
                this.setInputValidity('discountExpired', true);
                this.setInputValidity('inactiveGiftCard', true);
                this.setInputValidity('giftCardNotAllowed', true);
                this.setInputValidity('cannotAddMoreStoreCredit', true);
                this.setInputValidity('discountCodeExistsInCart', true);
            }

            getViewValueFromFormError(errorKey) {
                return get(this.promoCodeForm, `$error.${errorKey}[0].$viewValue`);
            }
        }
    }).name;



// WEBPACK FOOTER //
// ./src/app/components/orderSummary/components/promoCodeForm/promoCodeForm.js